import React from "react";
var __jsx = React.createElement;
import stl from "./CarsFinance.module.css";
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
var CarsFinance = function CarsFinance(_ref) {
  var cityName = _ref.cityName;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.CCF_container
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.CCF_content
  }, /*#__PURE__*/React.createElement("h2", null, t("تمويل السيارات وتقسيطها في {{cityName}}", {
    ns: "web_city",
    cityName: cityName
  })), /*#__PURE__*/React.createElement("p", null, t("اشتري سيارتك بأقساط ميسرة في مدينة {{cityName}} بكل سهولة من خلال نظام التمويل الميسر لكافة موديلات السيارات المستعملة والجديدة", {
    ns: "web_city",
    cityName: cityName
  })), /*#__PURE__*/React.createElement("a", {
    className: ["redBtn", stl.button].join(" "),
    href: createUrl("/financing")
  }, t("سيارات بالأقساط في {{cityName}}", {
    ns: "web_city",
    cityName: cityName
  }))), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/city/finance_cars.webp",
    alt: "cars finance image",
    width: 200,
    height: 164,
    loading: "lazy"
  })));
};
export default CarsFinance;